/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { ChevronDown, ChevronUp, Search, Plus, RotateCw } from 'lucide-react'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  OverlayTrigger,
  Popover,
  Row,
  Table
} from 'react-bootstrap'
import { Loader } from 'react-bootstrap-typeahead'
import { Link, useLocation } from 'react-router-dom'
import Select from 'react-select'
import { BadgeStatusPrLists } from '../../../components/atoms/StatusLabel'
import TableAction from '../../../components/atoms/Table/TableAction'
import TablePagination from '../../../components/atoms/Table/TablePagination'
import InputDatePicker from '../../../components/Input/DatePicker/InputDatePicker'
import ModalAddSelectStagingArea from '../../../components/modal/ReceiveML/ModalAddSelectStagingArea'
import api from '../../../config/AxiosInstance'
import { convertDateWithTime } from '../../../helpers/constants'
import * as Common from '../../../utils/Common'
import toast, { Toaster } from 'react-hot-toast'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const SelectStyles = {
  control: (base, state) => ({
    ...base,
    height: 45,
    minHeight: 45,
    borderRadius: '10px',
    borderColor: state.isFocused ? 'var(--primary-orange)' : '#e9ecef',
    boxShadow: state.isFocused ? '0 0 0 4px rgba(248, 157, 29, 0.1)' : 'none',
    backgroundColor: '#ffffff',
    border: '1px solid #e9ecef',
    fontSize: '0.9rem'
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '45px',
    padding: '0 12px'
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px'
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#495057'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? 'var(--primary-orange)'
      : state.isFocused
        ? '#fff5e6'
        : null,
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer'
  })
}

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

function InboundReturn() {
  const { state } = useLocation()
  const [data, setData] = useState([])
  const [dataRR, setDataRR] = useState([])
  const [seriesNumbers, setSeriesNumbers] = useState([])
  const refSrcWarehouses = useRef()
  const [loading, setLoading] = useState({
    data: false,
    create: false
  })
  const [inboundId, setInboundId] = useState(null)
  const [modalStagingArea, setModalStagingArea] = useState(false)
  const [receiveWarehouses, setReceiveWarehouses] = useState([])
  const [selectWarehouseId, setSelectWarehouseId] = useState(null)
  const [visibleModal, setVisibleModal] = useState({
    selectIR: false,
    seriesNumber: false
  })
  const [form, setForm] = useState({
    inbound_return_id: null,
    series_number: null
  })
  const [filter, setFilter] = useState({
    q: state?.q || '',
    receive_warehouse: state?.receive_warehouse || '',
    start_date: state?.start_date || '',
    end_date: state?.end_date || ''
  })
  const [debouncedQ, setDebouncedQ] = useState(filter.q)
  const [openSearch, setOpenSearch] = useState(false)

  const [meta, setMeta] = useState({
    per_page: 10,
    current_page: 1,
    total_row: 0,
    total_page: 0
  })

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQ(filter.q)
      if (filter.q !== debouncedQ) {
        setMeta((prev) => ({ ...prev, current_page: 1 }))
      }
    }, 1000)

    return () => {
      clearTimeout(handler)
    }
  }, [filter.q])

  const statusTextMapping = {
    unassigned: 'unassigned',
    waiting_rnr: 'waiting rnr',
    receiving_progress: 'receiving progress',
    rnr: 'receiving progress',
    waiting_om: 'waiting om',
    request_pnp: 'waiting om',
    waiting_pnp: 'waiting pnp',
    pnp: 'put away',
    put_away: 'put away',
    done: 'done',
    revised: 'waiting rnr'
  }

  const renderStagingArea = (item) => {
    if (item.status === 'unassigned' && !item?.staging) {
      return (
        <div
          className="d-flex flex-row gap-2 justify-content-end cursor-pointer text-muted"
          role="button"
          onClick={() =>
            handleModalStagingArea(item.id, item?.target_warehouse)
          }
        >
          <span>Staging Area</span>
          {openSearch ? (
            <ChevronUp size={14} className="fa-flip-horizontal ml-2 mt-1" />
          ) : (
            <ChevronDown size={14} className="fa-flip-horizontal ml-2 mt-1" />
          )}
        </div>
      )
    }
    return (
      <OverlayTrigger
        trigger={['hover', 'click']}
        key={'bottom'}
        placement={'bottom'}
        overlay={
          <Popover id={`popover-positioned-bottom`}>
            <Popover.Body>
              <p>{item?.staging}</p>
            </Popover.Body>
          </Popover>
        }
      >
        <div className="d-flex flex-row justify-content-end align-items-center">
          <p
            style={{ cursor: 'pointer', maxWidth: '80%', margin: 0 }}
            className="text-truncate"
          >
            {item?.staging}
          </p>
        </div>
      </OverlayTrigger>
    )
  }
  const renderStatus = (item) => (
    <BadgeStatusPrLists text={statusTextMapping[item.status] || 'done'} />
  )
  const handleSelectInboundReturn = (inboundReturnId) => {
    setForm((prevForm) => ({
      ...prevForm,
      inbound_return_id: inboundReturnId
    }))
    setVisibleModal((prevModal) => ({
      ...prevModal,
      selectIR: false
    }))
    setTimeout(() => {
      setVisibleModal((prevModal) => ({
        ...prevModal,
        seriesNumber: true
      }))
    }, 500)
  }
  const columns = [
    {
      key: 'created_at',
      label: 'Created',
      component: (item) => (
        <span className="text-muted">
          {convertDateWithTime(item.created_at)}
        </span>
      )
    },
    {
      key: 'code',
      label: '#IR',
      component: (item) => (
        <span className="fw-semibold text-primary">{item.code}</span>
      )
    },
    {
      key: 'target_warehouse',
      label: 'Target Warehouse',
      component: (item) => (
        <span className="text-muted">{item.target_warehouse}</span>
      )
    },
    {
      key: 'vehicle',
      label: 'Car',
      component: (item) => <span className="text-muted">{item.vehicle}</span>
    },
    {
      key: 'staging_area',
      label: 'Staging Area',
      component: (item) => renderStagingArea(item)
    },
    {
      key: 'status',
      label: 'Status',
      component: (item) => renderStatus(item)
    },
    {
      key: 'action',
      label: 'Action',
      component: (item) => (
        <TableAction>
          <Link to={`/inbound/inbound-return/detail/${item.id}`} state={filter}>
            <Button
              variant="light"
              className="btn-sm border rounded text-secondary"
              style={{ width: '32px', height: '32px', padding: 0 }}
            >
              <Search size={13} />
            </Button>
          </Link>
        </TableAction>
      )
    }
  ]

  const columnForm = [
    { key: 'code', label: 'RR' },
    { key: 'dc_no', label: 'DC' },
    { key: 'customer', label: 'Customer' },
    { key: 'warehouse_id', label: 'Source Warehouse' },
    {
      key: 'action',
      label: 'Action',
      component: (item) => (
        <TableAction key={item.id}>
          <Button
            variant="transparent"
            className="btn-primary-blue"
            onClick={() => handleSelectInboundReturn(item.rr_id)}
          >
            Select
          </Button>
        </TableAction>
      )
    }
  ]

  const handleChangeValueFilter = (e) => {
    const { name, value } = e?.target || e
    const newFilter = { ...filter, [name]: value }

    if (name === 'start_date' && value && filter.end_date) {
      if (moment(value) > moment(filter.end_date)) {
        newFilter.end_date = value
      }
    }

    if (name === 'end_date' && value && filter.start_date) {
      if (moment(value) < moment(filter.start_date)) {
        newFilter.start_date = value
      }
    }

    setFilter(newFilter)
  }

  const handleResetFilter = () => {
    setFilter({
      q: '',
      receive_warehouse: '',
      start_date: '',
      end_date: ''
    })
    setDebouncedQ('')
    refSrcWarehouses?.current?.clearValue()
    setMeta((prevMeta) => ({
      ...prevMeta,
      current_page: 1
    }))
  }

  const handleOnChangeMeta = (e) => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      per_page: parseInt(e.target.value, 10),
      current_page: 1
    }))
  }
  const fetchIR = async () => {
    try {
      setLoading((prevLoading) => ({
        ...prevLoading,
        data: true
      }))
      const res = await api.get('/inbound/return', {
        params: {
          ...filter,
          q: debouncedQ,
          per_page: meta.per_page,
          page: meta.current_page
        }
      })
      const { data } = res
      if (data.success) {
        const { data: dataResponse, metadata: metaResponse } = data
        setData(dataResponse)
        setMeta(metaResponse)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoading((prevLoading) => ({
        ...prevLoading,
        data: false
      }))
    }
  }
  const fetchRR = async () => {
    try {
      setLoading((prevLoading) => ({
        ...prevLoading,
        create: true
      }))
      const res = await api.get('/inbound/return/rr')
      const { data } = res
      if (data.success) {
        const { data: dataResponse } = data
        setDataRR(dataResponse)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoading((prevLoading) => ({
        ...prevLoading,
        create: false
      }))
    }
  }
  const fetchSeriesNumberRR = async () => {
    try {
      const res = await api.get(
        `/inbound/return/series/${form.inbound_return_id}`
      )
      const { data } = res
      if (data.success) {
        const { data: dataResponse } = data
        setSeriesNumbers(dataResponse)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }
  const handlePageChange = (data) => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      current_page: data.selected + 1
    }))
    window.scrollTo(0, 0)
  }

  const fetchReceiveWarehouse = async () => {
    try {
      const response = await api.get('/master/warehouses/all?forUser=1')
      const { data } = response
      if (data.success) {
        setReceiveWarehouses(data.data)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const createIR = async () => {
    try {
      setLoading((prevLoading) => ({
        ...prevLoading,
        create: true
      }))
      const payload = {
        rr_id: form.inbound_return_id,
        series_number: form.series_number
      }
      const res = await api.post('inbound/return', payload)
      const { data } = res
      if (data.success) {
        Common.showPopUpSuccessMessage(data.message)
        setVisibleModal((prevModal) => ({
          ...prevModal,
          selectIR: false,
          seriesNumber: false
        }))
        setForm((prevForm) => ({
          ...prevForm,
          series_number: null,
          inbound_return_id: null
        }))
        fetchIR()
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoading((prevLoading) => ({
        ...prevLoading,
        create: false
      }))
    }
  }

  const handleModalStagingArea = (inboundId, warehouseId) => {
    setModalStagingArea(true)
    setInboundId(inboundId)
    setSelectWarehouseId(warehouseId)
  }

  const handleCloseFormCreate = () => {
    const checkVisible = Object.keys(visibleModal).find(
      (key) => visibleModal[key]
    )
    if (checkVisible === 'selectIR') {
      setVisibleModal((prevModal) => ({
        ...prevModal,
        selectIR: false
      }))
      setForm({
        inbound_return_id: null,
        series_number: null
      })
    }
    if (checkVisible === 'seriesNumber') {
      setVisibleModal((prevModal) => ({
        ...prevModal,
        selectIR: false,
        seriesNumber: false
      }))
      setTimeout(() => {
        setVisibleModal((prevModal) => ({
          ...prevModal,
          selectIR: true
        }))
        setForm((prevForm) => ({
          ...prevForm,
          series_number: null
        }))
      }, 500)
    }
  }
  const getModalTitleForm = () => {
    if (visibleModal.selectIR) {
      return {
        title: 'Select RR to create IR',
        size: 'xl'
      }
    }
    if (visibleModal.seriesNumber) {
      return {
        title: 'Select Series',
        size: 'md'
      }
    }
    return {
      title: '',
      size: 'md'
    }
  }

  useEffect(() => {
    if (
      (filter.start_date && !filter.end_date) ||
      (!filter.start_date && filter.end_date)
    ) {
      return
    }

    fetchIR()
  }, [
    debouncedQ,
    filter.receive_warehouse,
    filter.start_date,
    filter.end_date,
    meta.per_page,
    meta.current_page
  ])

  useEffect(() => {
    fetchReceiveWarehouse()
  }, [])

  useEffect(() => {
    if (visibleModal.selectIR) {
      fetchRR()
    }
  }, [visibleModal])

  useEffect(() => {
    if (form.inbound_return_id) {
      fetchSeriesNumberRR()
    }
  }, [form.inbound_return_id])
  return (
    <>
      <Container fluid className="px-4">
        <Toaster />
        <Row className="mb-4 align-items-center">
          <Col>
            <div className="d-flex justify-content-between align-items-center">
              <h3 style={headerTitleStyle}>Inbound Return</h3>
              <div className="d-flex gap-2">
                <Button
                  variant="light"
                  className="text-secondary fw-bold rounded px-3 border"
                  onClick={handleResetFilter}
                  style={{ fontSize: '0.85rem' }}
                >
                  <RotateCw size={14} className="me-2" />
                  Reset Filters
                </Button>
                <Button
                  className="btn btn-primary-blue rounded px-3"
                  onClick={() =>
                    setVisibleModal((prevVisibleModal) => ({
                      ...prevVisibleModal,
                      selectIR: !prevVisibleModal.selectIR
                    }))
                  }
                >
                  <Plus size={14} />
                  <span className="ms-2 fw-bold">Create IR</span>
                </Button>
              </div>
            </div>
          </Col>
        </Row>

        <Card style={cardFilterStyle}>
          <Row className="g-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle} htmlFor="q">
                  #inbound return
                </Form.Label>
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #e9ecef',
                      borderRight: 'none',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px'
                    }}
                  >
                    <Search size={16} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    id="q"
                    name="q"
                    value={filter.q}
                    onChange={(e) => handleChangeValueFilter(e)}
                    placeholder="Search Inbound Return..."
                    style={{
                      ...FormControlStyle,
                      borderLeft: 'none',
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0
                    }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="sjdelivend">
                <Form.Label style={labelStyle}>RECEIVE WAREHOUSE</Form.Label>
                <Select
                  isClearable
                  id="receive_warehouse"
                  defaultValue={filter?.receive_warehouse || ''}
                  styles={SelectStyles}
                  onChange={(e) => {
                    if (!e) {
                      e = {
                        target: refSrcWarehouses,
                        value: ''
                      }
                    }
                    handleChangeValueFilter({
                      value: e?.value,
                      name: 'receive_warehouse'
                    })
                    setMeta((prev) => ({ ...prev, current_page: 1 }))
                  }}
                  options={receiveWarehouses?.map((warehouse) => ({
                    value: warehouse.id,
                    label: warehouse.warehouse_name
                  }))}
                  placeholder="Select Warehouse"
                  isSearchable
                  ref={refSrcWarehouses}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Start Date</Form.Label>
                <div
                  style={FormControlStyle}
                  className="d-flex align-items-center px-2"
                >
                  <InputDatePicker
                    value={filter?.start_date}
                    onChange={(date) => {
                      handleChangeValueFilter({
                        target: {
                          name: 'start_date',
                          value: date ? moment(date).format('YYYY-MM-DD') : ''
                        }
                      })
                      setMeta((prev) => ({ ...prev, current_page: 1 }))
                    }}
                    maxDate={filter.end_date ? new Date(filter.end_date) : null}
                    clearIcon
                  />
                </div>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>End Date</Form.Label>
                <div
                  style={FormControlStyle}
                  className="d-flex align-items-center px-2"
                >
                  <InputDatePicker
                    value={filter?.end_date}
                    onChange={(date) => {
                      handleChangeValueFilter({
                        target: {
                          name: 'end_date',
                          value: date ? moment(date).format('YYYY-MM-DD') : ''
                        }
                      })
                      setMeta((prev) => ({ ...prev, current_page: 1 }))
                    }}
                    minDate={
                      filter.start_date ? new Date(filter.start_date) : null
                    }
                    clearIcon
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Card>

        <Row className="mt-3">
          <Table
            hover
            responsive
            className="shadow-sm mb-5 bg-white"
            style={{
              borderRadius: '12px',
              overflow: 'hidden',
              fontSize: '0.9rem'
            }}
          >
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                {columns.map((column) => (
                  <th
                    className="align-middle p-2"
                    key={column.key}
                    style={tableHeaderStyle}
                  >
                    <span>{column.label}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody style={{ fontSize: '12px' }}>
              {loading.data && (
                <tr>
                  <td colSpan={columns.length} className="text-center p-5">
                    <Loader />
                  </td>
                </tr>
              )}
              {!loading.data && !data.length && (
                <tr>
                  <td
                    colSpan={columns.length}
                    className="text-center fw-bold p-5 text-muted"
                  >
                    No Data Found
                  </td>
                </tr>
              )}
              {!loading.data &&
                data.length > 0 &&
                data.map((item, index) => (
                  <tr
                    key={`${item.id}-${index}`}
                    style={{ borderBottom: '1px solid #f0f0f0' }}
                  >
                    {columns.map((column) => (
                      <td key={column.key} className="p-2 align-middle">
                        {column.component
                          ? column.component(item)
                          : item[column.key]}
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={8} className="p-3 border-top-0">
                  <TablePagination
                    meta={meta}
                    handleOnChangeMeta={handleOnChangeMeta}
                    handlePageChange={handlePageChange}
                  />
                </td>
              </tr>
            </tfoot>
          </Table>
        </Row>
        <ModalAddSelectStagingArea
          show={modalStagingArea}
          onHide={() => {
            setModalStagingArea(false)
            setSelectWarehouseId('')
            setInboundId(null)
          }}
          warehouseId={selectWarehouseId}
          inboundId={inboundId}
          refreshData={() => fetchIR()}
          type="inbound-return"
        />
        <Modal
          show={Object.keys(visibleModal).find(
            (key) => visibleModal[key] === true
          )}
          centered
          size={getModalTitleForm()?.size}
          onHide={handleCloseFormCreate}
        >
          <Modal.Header closeButton>
            <Modal.Title>{getModalTitleForm()?.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {visibleModal.selectIR && (
              <Table
                hover
                responsive
                className="shadow-sm mb-5 bg-white rounded"
                size="sm"
                style={{ fontSize: '14px' }}
              >
                <thead className="table-secondary">
                  <tr>
                    {columnForm.map((column) => (
                      <th className="align-middle p-2" key={column.key}>
                        <span>{column.label}</span>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading.create && (
                    <tr>
                      <td colSpan={columnForm.length} className="text-center">
                        <Loader />
                      </td>
                    </tr>
                  )}
                  {!loading.create && !dataRR.length && (
                    <tr>
                      <td
                        colSpan={columnForm.length}
                        className="text-center fw-bold p-3"
                      >
                        There is no ‘RR’ ticket ready to be made as ‘IR’ ticket
                      </td>
                    </tr>
                  )}
                  {!loading.create &&
                    dataRR.length > 0 &&
                    dataRR.map((item, index) => (
                      <tr key={`${item.id}-${index}`}>
                        {columnForm.map((column) => (
                          <td key={column.key} className="p-2 align-middle">
                            {column.component && column.component(item)}
                            {!column.component && item[column.key]}
                          </td>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}
            {visibleModal.seriesNumber && (
              <>
                <p>Select series to continue!</p>
                <Form.Label
                  htmlFor="series_number"
                  style={{ fontSize: '12px' }}
                  className="text-muted"
                >
                  Series
                </Form.Label>
                <Form.Select
                  aria-label="Default select example"
                  name="series_number"
                  id="series_number"
                  onChange={(e) =>
                    setForm((prevForm) => ({
                      ...prevForm,
                      series_number: e.target.value
                    }))
                  }
                  value={form.series_number || ''}
                >
                  <option value="">Select Series Number</option>
                  {seriesNumbers.length > 0 &&
                    seriesNumbers?.map((seriesNumber, index) => (
                      <option key={seriesNumber.name} value={seriesNumber.name}>
                        {seriesNumber.name}
                      </option>
                    ))}
                </Form.Select>
              </>
            )}
          </Modal.Body>
          {visibleModal.seriesNumber && (
            <Modal.Footer>
              <Button variant="transparent" onClick={handleCloseFormCreate}>
                Cancel
              </Button>
              <Button
                variant="transparent"
                className={
                  form.inbound_return_id &&
                  form.series_number &&
                  !loading.create
                    ? 'btn-primary-orange'
                    : 'btn-secondary opacity-50'
                }
                disabled={
                  !form.inbound_return_id ||
                  !form.series_number ||
                  loading.create
                }
                onClick={createIR}
              >
                Create
              </Button>
            </Modal.Footer>
          )}
        </Modal>
      </Container>
    </>
  )
}

export default InboundReturn
